import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import AdjustmentInfoPerilakuKerja from '../AdjustmentInfoPerilakuKerja'

import type { HTMLProps } from 'react'

interface PanelPerilakuKerjaProps extends HTMLProps<HTMLDivElement> {
  adjustmentText?: string
  title?: string
  titleIndikatorPerilaku?: string
  originalIndikatorPerilaku?: string
  indikatorPerilaku?: string
  titlePerwujudanPerilaku?: string
  originalPerwujudanPerilaku?: string
  perwujudanPerilaku?: string
  className?: string
}

const PanelPerilakuKerja = ({
  adjustmentText = 'Ada penyesuaian dari atasan',
  title = '',
  titleIndikatorPerilaku = 'Indikator Perilaku',
  originalIndikatorPerilaku = '',
  indikatorPerilaku = '',
  titlePerwujudanPerilaku = 'Perwujudan Perilaku',
  originalPerwujudanPerilaku = '',
  perwujudanPerilaku = '',
  className = '',
  ...otherProps
}: PanelPerilakuKerjaProps) => {
  const isChanged =
    !!originalIndikatorPerilaku &&
    !!originalPerwujudanPerilaku &&
    (originalIndikatorPerilaku !== indikatorPerilaku ||
      originalPerwujudanPerilaku !== perwujudanPerilaku)

  return (
    <div
      data-testid="panel-perilaku-kerja"
      className={clsx('border border-gray-30 rounded p-6', className)}
      {...otherProps}
    >
      {isChanged && (
        <AdjustmentInfoPerilakuKerja
          text={adjustmentText}
          className="mb-6"
          title={title}
          originalIndikatorPerilaku={originalIndikatorPerilaku}
          indikatorPerilaku={indikatorPerilaku}
          originalPerwujudanPerilaku={originalPerwujudanPerilaku}
          perwujudanPerilaku={perwujudanPerilaku}
        />
      )}

      <Text variant="heading-lg">{title}</Text>
      <Text color="subdued" className="mb-1 mt-6">
        {titleIndikatorPerilaku}
      </Text>
      <Text variant="action" className="mb-1">
        {indikatorPerilaku}
      </Text>
      <Text color="subdued" className="mb-1 mt-6">
        {titlePerwujudanPerilaku}
      </Text>
      <Text variant="action" className="mb-1">
        {perwujudanPerilaku}
      </Text>
    </div>
  )
}

export default PanelPerilakuKerja
